<template>
  <div class="mt-8">
    <h3 class="section-title mb-2">{{ $t('shop_information') }}</h3>
    <ul class="place-info">
      <li v-if="place.zipcode && place.zipcode.length > 0">
        <span>{{ $t('location') }}：</span>
        <span>〒{{ place.zipcode }} {{ place.address }}</span>
      </li>
      <li v-if="!place.zipcode || place.zipcode.length <= 0">
        <span>{{ $t('location') }}：</span>
        <span>{{ place.address }}</span>
      </li>
      <li v-if="place.phone_number && place.phone_number.length > 0">
        <span>{{ $t('tel') }}:</span>
        <a :href="`tel:${ place.phone_number }`" class="inline-block text-link_darker">
          <span class="mr-1">{{ place.phone_number }}</span>
          <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" class="inline w-4">
              <path d="m556.47567 279.782859-.775371-.608385c-.356217-.279146-.875557-.216638-1.155136.139573l-2.039685 2.600512c-.279579.356211-.216641.875971.139576 1.155117l1.113606.873831c-.423864.646916-.986447 1.359339-1.721144 2.093596-.734698.734685-1.447132 1.297687-2.094059 1.721544l-.873845-1.113588c-.278723-.356211-.798919-.419147-1.154708-.139573l-2.600983 2.039651c-.355789.279146-.418726.799334-.139576 1.155117l.608395.775358c1.337526 1.337504 4.815351.028257 7.768269-2.924612 2.952491-2.952442 4.262188-6.430637 2.924661-7.768141" transform="translate(-544 -278)"/>
            </svg>
        </a>
      </li>
      <li v-if="place.business_hours && place.business_hours.length > 0" class="flex items-start">
        <span>{{ $t('business_hours') }}：</span>
        <span>{{ place.business_hours }}</span>
      </li>
      <li v-if="place.regular_holiday > 0">
        <span>{{ $t('holoday') }}：</span>
        <span>{{ place.regular_holiday }}</span>
      </li>
      <li v-if="place.url && place.url.length > 0" class="flex items-start">
        <span>{{ $t('website') }}：</span>
        <span>
          <a :href="place.url" class="break-all text-link">{{ place.url }}</a>
        </span>
      </li>
      <li class="flex items-start">
        <div class="mt-4 w-full">
          <a href="https://miyagi.tohoku-maas.com/recommend/spots?filter=sPalGourmet" class="button-secondary block button-icon icon-right" target="_blank">
            <span>S-PALショップを見る</span>
            <svg height="20" viewBox="0 0 20 20" width="20" xmlns="http://www.w3.org/2000/svg"><path d="m10 3.20710678v6.29289322c0 .27614237-.22385763.5-.5.5h-6.29289322c-.27614237 0-.5-.22385763-.5-.5 0-.13260824.05267842-.2597852.14644661-.35355339l6.29289322-6.29289322c.19526215-.19526215.51184463-.19526215.70710678 0 .09376819.09376819.14644661.22094515.14644661.35355339z" fill-rule="evenodd" transform="matrix(.70710678 -.70710678 .70710678 .70710678 -.485281 10)"/></svg>
          </a>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    place: {
      type: Object,
      required: true
    }
  }
}
</script>
